module.exports = __webpack_public_path__ + "static/media/android_app_store.e3ea015c.svg";